<template>
  <modal transition="pop-out" name="bulk-discount-modal" :height="300">
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-2 error-msg" v-if="updateErrMsg">{{updateErrMsg}}</div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">Discount(%)</label>
          <input v-model="discount" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Eg: 20">
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">Select Items</label>
          <el-select v-model="items" remote multiple :remote-method="searchForItems"
                     collapse-tags filterable placeholder="Search by product name..."
                     class="appearance-none rounded w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
            <el-option
              v-for="prod in products"
              :key="prod.id"
              :label="prod.name"
              :value="prod.id">
            </el-option>
          </el-select>
        </div>
        <div class="flex justify-start">
          <el-button @click="submit" type="primary" :updating="updating">Apply</el-button>
          <el-button @click="closeDialog" type="text" class="pl-4">Cancel</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import axios from 'axios';

const { CancelToken } = axios;
let cancel;

export default {
  name: 'BulkDiscountForm',
  data() {
    return {
      page: 1,
      error: false,
      updating: false,
      updateErrMsg: '',
      discount: '',
      products: [],
      items: [],
      discountApplied: false,
    };
  },
  methods: {
    async closeDialog() {
      this.$emit('modalClosed');
      this.$modal.hide('bulk-discount-modal');
    },
    async searchForItems(keyword) {
      if (keyword !== '') {
        if (cancel !== undefined) { cancel(); }

        try {
          const response = await axios.get(`${process.env.VUE_APP_ECOMMERCE_BASE_API}/search`, {
            cancelToken: new CancelToken(((c) => { cancel = c; })),
            params: { keyword, perPage: 1000 },
          });
          this.products = response.data.data.data;
        } catch (error) {
          if (axios.isCancel(error)) {
            console.log('post Request canceled');
          }
        }
      }
    },
    async fetchAllProducts() {
      try {
        await this.$store.dispatch('InventoryModule/Products/fetchAllProducts', { page: this.page, limit: this.limit });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    async submit() {
      try {
        if (this.discount === '' || this.items === []) {
          this.updateErrMsg = 'No field should be empty.';
          return false;
        }
        this.updating = true;
        const formData = {
          discount: this.discount,
          item_ids: this.items,
        };
        await this.$store.dispatch('InventoryModule/Products/applyBulkDiscount', { formData });
        this.$emit('modalClosed');
        this.$modal.hide('bulk-discount-modal');
        this.items = [];
        this.discount = '';
        this.updateErrMsg = '';
        this.$notify.success({
          title: 'Success',
          message: 'Discount has been applied to product(s)',
        });
      } catch (e) {
        this.updating = false;
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong',
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.error-msg {
  font-size: 12px;
  color: #dd071a;
}
</style>
